import { render, staticRenderFns } from "./ProjectLogDisputeModal.vue?vue&type=template&id=46f0f4b4&scoped=true&"
import script from "./ProjectLogDisputeModal.vue?vue&type=script&lang=js&"
export * from "./ProjectLogDisputeModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectLogDisputeModal.vue?vue&type=style&index=0&id=46f0f4b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f0f4b4",
  null
  
)

export default component.exports